/**
 * Good example of redirecting a front-end call to the services to perform work
 */
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ContextService, LoginData } from '../context.service';
import { Observable, ObservableInput, of } from 'rxjs';

@Component({
    selector: 'mutara-claim',
    templateUrl: './claim.component.html',
    standalone: false
})

export class ClaimComponent implements OnInit {
  successful: boolean = false;
  message: string = '';
  loading: boolean = true;

  login: LoginData | undefined;
  formGrouping: UntypedFormGroup | undefined;
  hide = true;

  constructor(private http: HttpClient, private router: Router, private context: ContextService, private fb: UntypedFormBuilder) {
    this.context.setProgressIndeterminate(true);
  }

  ngOnInit(): void {
    this.context.showProgress(false);

    this.formGrouping = this.fb.group({
      formArray: this.fb.array(
        [this.fb.group({
          password: ['', Validators.compose([Validators.required, Validators.pattern(/(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/)])]
        })])
    });
    this.http.post('$service/verify-identity', { entityId: this.router.url.split('/').pop() })
      .subscribe({
        next: (result: any) => {
          // This will always return, the response will include any errors to be displayed
          this.successful = !result.error;
          this.login = result;
          this.message = result.message;
          this.context.showProgress(false);
        }
      });
  }

    // This pulls the array of groups from the group of arrays.... 
    get formArray(): AbstractControl | undefined | null {
      return this.formGrouping?.get('formArray');
    }
  
  save($event : Event) {
    let parameters: any = {};
    this.formArray?.value.forEach( (section : any) => Object.assign(parameters, section));

    parameters.password = parameters?.password.trim();

    console.log('parameters.password', parameters.password);

    // This is a chain of events stacked, should be piped
    this.http.post('$service/register-existing', Object.assign( this.login ?? {}, {password: parameters?.password.trim(), user: this.login?.email}) ).subscribe({
      error: (httpError): ObservableInput<{}> => {
        console.log('Default Config with error %O', httpError);
        return of({ error: httpError });
      },
      next: (result: { error?: any }) => {
        if (!result?.error) {
          this.login = <LoginData>result;
          this.context.setLoginData(this.login);
          // The login data change lazily, so send what we know 
//          this.http.post('$service', { user: this.login.username, pwd: parameters?.password.trim() });
          // Login and redirect happens in the server-login.service
          this.context.setLayoutId( this.login.defaultLayout );
          this.router.navigate(['/apply',this.login?.defaultLayout?.layoutId ??''], {replaceUrl: true});
     
        } else {
          this.context.changeMessage('Email already registered with different name');
        }
      }
    });
  }

}
